import React from "react";

const Ellipse = ({ color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="16"
      viewBox="0 0 26 16"
      fill="none"
    >
      <path
        d="M13.0001 1.2C7.24158 1.2 2.5734 4.24446 2.5734 8C2.5734 11.7555 7.24158 14.8 13.0001 14.8C18.7586 14.8 23.4267 11.7555 23.4267 8C23.4267 4.24446 18.7586 1.2 13.0001 1.2ZM0.733398 8C0.733398 3.58172 6.22537 0 13.0001 0C19.7748 0 25.2667 3.58172 25.2667 8C25.2667 12.4183 19.7748 16 13.0001 16C6.22537 16 0.733398 12.4183 0.733398 8Z"
        fill={color}
      />
    </svg>
  );
};

export default Ellipse;
